<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/erBuYP/tc-custom/9781612436999.jpg?1740428999044" alt="This image is the cover for the book Ketogenic Pressure Cooker"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ketogenic Pressure Cooker
      </h1>
      <p class="bookDescription body article font2">
        <p>The first book to combine the low-carb, fat-burning ketogenic diet with the popular, fast, and easy pressure cooking methodThanks to your powerful pressure cooker and this helpful cookbook, following the ketogenic diet has never been easier. Start with protein. Add fresh veggies. Toss in some spices. Press start. You’re on your way to healthy eating!Cut cook time, boost nutrients and supercharge flavor with this book’s mouthwatering recipes, such as:• Lemon Chicken Soup• Salmon Alfredo Zoodles• Korean-Inspired Pulled Pork• Barbecue Beef Boneless Short Ribs• Spicy Coconut Prawns• Turkey Wing Vindaloo• Spaghetti Squash and Ham Tetrazzini• Hot Salami and Kale Soup• Plus desserts, broths and more!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aileen Ablog
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d3a1868